module.exports = __webpack_public_path__ + "media/images/old_fashioned_way_text-3393ff5118d43968185326ebc4138c85.png";